import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { PrimaryButton } from 'shared/components/button'
import { AccessDenied } from 'shared/errors/access-denied'
import { UnauthorizedResponse } from 'shared/errors/unauthorized-response'
import { joinCommunity } from '../api/community-api'

function JoinForm({
  showRegistration,
  disabled,
}: {
  showRegistration: () => void
  disabled: boolean
}) {
  const router = useRouter()
  const { t } = useTranslation()
  const { communityPath } = router.query
  const [isLoading, setIsLoading] = useState(false)

  async function join() {
    try {
      setIsLoading(true)
      await joinCommunity(communityPath as string)
      await router.replace(`/community/${communityPath}`)
    } catch (e) {
      setIsLoading(false)
      if (e instanceof UnauthorizedResponse) {
        showRegistration()
      } else if (e instanceof AccessDenied) {
        await router.replace(`/community/403`)
      }
    }
  }

  return (
    <PrimaryButton isLoading={isLoading} disabled={disabled || isLoading} onClick={join}>
      {t('join_form.button.join.title')}
    </PrimaryButton>
  )
}

export default JoinForm
